import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useFetchApplicationDetails, useFetchChannelDetails } from "../../apis/integrationApis";
import { useForm } from "react-hook-form";
import Install from "./_components/Install";

const HowInstall: React.FC = () => {
  const { id } = useParams();
  // const { data, refetch } = useFetchChannelDetails(id ?? "");
  // const { data, refetch } = useFetchApplicationDetails(id ?? "");

  // useEffect(() => {
  //   refetch();
  // }, [id]);

  type FormValues = {
    toClient: string;
    products: { productId: string }[];
  };

  const {
    register: assignRegister,
    handleSubmit: handleAssignSubmit,
    clearErrors: clearAssignErrors,
    reset: assignReset,
    setValue: setAssignValue,
    watch: assignWatch,
    formState: { errors: assignErrors },
  } = useForm<FormValues>();
  return (
    <>
      <div className="p-4 space-y-4">
        <Install
          setValue={setAssignValue}
          watch={assignWatch}
          register={assignRegister}
          errors={assignErrors}
          clearErrors={clearAssignErrors}
          // data={data}   
        />
      </div>
    </>
  );
};

export default HowInstall;
